<template>
  <div class="c-thanks">
    <div class="l-background">
      <div class="c-panel">
        <div class="c-thanks__body">
          <header>
            <h1 class="c-thanks__tit">Thank you</h1>
          </header>
          <div class="c-thanks__content">
            <div class="c-thanks__img-box">
              <img
                class="c-thanks__img"
                alt="NIYU logo"
                src="/assets/image/kitty_eye.png"
              >
            </div>
            <div class="c-thanks__text-box">
              <p class="c-thanks__text">お問い合わせいただきありがとうございました。<br>確認メールが届いていない場合には、メールアドレスが誤っているか、確認メールが迷惑メールフォルダ等に振り分けられている可能性がありますので、再度ご確認をお願いいたします。<br>なお、お問い合わせ内容につきましては、通常3営業日程度を目処に、ご回答させていただきます。<br>今しばらくお待ちください。</p>
            </div>
          </div>
          <div>
            <nav class="c-nav">
              <li class="c-nav__item">
                <router-link
                  class="c-nav__link"
                  to="/profile"
                >profile</router-link>
              </li>
              <li class="c-nav__item">
                <router-link to="/skills">skills</router-link>
              </li>
              <li class="c-nav__item">
                <router-link to="/works">works</router-link>
              </li>
              <li class="c-nav__item">
                <router-link to="/contact">contact</router-link>
              </li>
            </nav>
          </div>
        </div>

      </div>
      <Footer />
    </div>
  </div>

</template>

<script>
// @ is an alias to /src
import Footer from "@/components/Footer.vue";

export default {
  name: "Thanks",
  components: {
    Footer
  }
};
</script>


<style lang="scss">
.c-thanks
{
    position: relative;

    & .c-nav
    {
        @media only screen and (max-width: 768px)
        {
            display: block;
        }
    }

    & .l-background
    {
        height: 100vh;

        @media only screen and (max-width: 768px)
        {
            animation: none;

            background: url(/assets/image/bg.jpg) repeat;
            background-size: 60%;
        }
    }
    &__body
    {
        border: 2px solid #c6c0bb;
    }

    &__tit
    {
        font-size: 8rem;
        font-weight: 400;

        position: relative;

        text-align: center;

        border-bottom: 2px solid #c6c0bb;

        @media only screen and (max-width: 768px)
        {
            font-size: 4rem;
        }

        &::after
        {
            position: absolute;
            right: -55px;
            bottom: -130px;

            display: inline-block;

            width: 230px;
            height: 180px;

            content: '';
            -webkit-animation-name: fadein;
                    animation-name: fadein;
            -webkit-animation-duration: 2s;
                    animation-duration: 2s;

            background: url(/assets/image/thanks_contact.png) no-repeat;
            background-size: contain;

            @media only screen and (max-width: 768px)
            {
                right: -18px;
                bottom: -82px;

                width: 150px;
            }
        }
    }

    &__content
    {
        font-size: 2.4rem;

        display: flex;
        align-items: center;
        justify-content: center;

        padding: 40px 0;

        border-bottom: 2px solid #c6c0bb;

        @media only screen and (max-width: 768px)
        {
            padding: 20px 0;
        }
    }

    &__img
    {
        width: 78px;

        &-box
        {
            width: 20%;

            text-align: center;
        }
    }

    &__text
    {
        font-size: 1.6rem;

        display: inline-block;

        text-align: left;
        @media only screen and (max-width: 768px)
        {
            font-size: 1.4rem;

            padding-left: 15px;
        }

        &-box
        {
            width: 80%;

            text-align: center;
        }
    }

    & .c-panel
    {
        position: absolute;
        top: 50%;
        left: 50%;

        width: 750px;
        padding: 100px 90px;

        -webkit-transform: translateY(-50%) translateX(-50%);
                transform: translateY(-50%) translateX(-50%);

        @media only screen and (max-width: 768px)
        {
            width: 100%;
            padding: 20px;
        }
    }
}

</style>
